import { createAsyncThunk } from "@reduxjs/toolkit";
import { customFetch } from "../lib/network/Axios";
import config from "../config";
import { Donation, DonationFilter } from "../types/donation.types";

const BASE_URL = config.apiBaseUrl;

/** @deprecated Use DonationFilter from types/donation.types.ts */
export type FetchDonationsFilter = DonationFilter;

export const getAllDonations = createAsyncThunk(
    "donation/getAll",
    async (filters: DonationFilter = {}) => {
        const response = await customFetch.post(
            `${BASE_URL}/donations/filtered`,
            filters,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    }
);

/** @deprecated Use getAllDonations thunk for Redux integration */
export const fetchAllDonations = async (filters: DonationFilter = {}) => {
    try {
        const response = await customFetch.post(
            `${BASE_URL}/donations/filtered`,
            filters,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        return response;
    } catch (err) {
        console.log('fetchAllDonations: ', err);
        throw err;
    }
};

export const fetchAllDonors = async () => {
    try {
        const response = await customFetch.get(`${BASE_URL}/donors`);
        return response;
    } catch (err) {
        console.log('fetchAllDonors: ', err);
        throw err;
    }
};

export const fetchAllShipments = async () => {
    try {
        const response = await customFetch.get(`${BASE_URL}/shipments`);
        return response;
    } catch (err) {
        console.log('fetchAllShipments: ', err);
        throw err;
    }
};

export const createOrganization = async (org: { name: string; url: string }) => {
    try {
        const response = await customFetch.post(
            `${BASE_URL}/organizations`,
            org,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (err) {
        console.log('createOrganization: ', err);
        throw err;
    }
};

export const createDonation = async (donation: any) => {
    try {
        const response = await customFetch.post(
            `${BASE_URL}/donations`,
            donation,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data as Donation;
    } catch (err) {
        console.log('createDonation: ', err);
        throw err;
    }
};

export const createBulkDonations = async (donations: any[]) => {
    try {
        const response = await customFetch.post(
            config.apiBaseUrl + `/donations/bulk`,
            { donations: donations },
            {
            headers: {
                'Content-Type': 'application/json'
            }
            }
        );
        return response;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const createShipment = async (
  shipment: any
) => {
  try {
    const response = await customFetch.post(
      `${BASE_URL}/shipments`,
      shipment,
      {
        headers: {
          "Content-Type": "application/json"
        },
      }
    );
    return response;
  } catch (err) {
    console.log("createShipment:", err);
    throw err;
  }
};

